import { commanServicer } from "./common.services";

async function saveOrUpdateEmailTemplate(payload: any) {
    return await commanServicer.fetchRequest(
        JSON.stringify(payload),
        true,
        'EmailTemplate/saveupdateemailtemplate',
        'POST'
    );
}

async function getEmailTemplateDetail(id: any) {
    return await commanServicer.fetchRequest(
        '',
        true,
        `EmailTemplate/getemailtemplatedetail?id=${id}`,
        'GET'
    );
}

export const EmailTemplateService = {
    saveOrUpdateEmailTemplate,
    getEmailTemplateDetail,
};
